<template>
    <div class="h-full">
        <TopAppBarDrawer></TopAppBarDrawer>
        
         <main class="main-wrapper flex-grow-1 pdb-50">
             <div class="d-flex align-items-center bg-white fix-header-title" >
                <div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title d-flex align-items-center justify-content-center">
                     <div class="font-m">{{$t('1288')}}</div>
                    </div>
                    <!-- <div class="mgr-24 right-button">
                        <button class="mdc-icon-button">
                             <i class="material-icons t-headline6">search</i>
                         </button>
                    </div> -->
                </div>
           
            <div class="divider"></div>
            <NoData :msgData="{msg1:'1367',msg2:'1368'}" v-if="isNoData==true" ></NoData>
            <div class="container container--narrow pdt-50" v-if="isNoData==false">
                <div class="mdc-card pdt-8 pdb-8">
        
            <div v-for="(order, index) in listData" :key="index" @click="movePurchaseRefundView(order.id)" @keypress="movePurchaseRefundView(order.id)" tabindex="0">
                <div class="pda-24 cursor-pointer">
                     <!-- 스킬패스 / 온라인클래스 / 시험 -->
                     <div class="t-body3 t-line-h-24 t-color-bodyGrayA font-r" v-if="order.category && order.category.key === 'ONLINE'">
                        {{$t('3400')}}
                    </div>
                    <div class="t-body3 t-line-h-24 t-color-bodyGrayA font-r" v-if="order.category && order.category.key === 'MICRO_ONLINE'">
                        {{$t('30236')}}
                    </div>
                    <div class="t-body3 t-line-h-24  t-color-bodyGrayA font-r" v-else-if="order.category && order.category.key === 'EXAM'">
                        {{$t('3401')}}
                    </div>
                    
                    <div class="t-color-headlineBlack l-spacing42 font-r mgt-4 t-body1">
                        {{order.productName}}
                    </div>
                    
                    <div class="t-body3 mgt-16 d-flex flex-row justify-content-between align-items-center">
                        <div>
                            <span class="l-spacing39 t-color-headlineBlack font-r t-body3" v-if="order.status && order.status.value==='REFUNDED_FREE'">
                                {{$t('3407')}}
                            </span>
                            <span class="l-spacing39 t-color-headlineBlack font-r t-body3" v-else-if="order.status && order.status.value==='REQUEST' || order.status.value==='REQUEST_REFUND'">
                                {{$t('3408')}}
                            </span>
                            <span class="l-spacing39 t-color-headlineBlack font-r t-body3" v-else-if="order.status && order.status.value==='REFUNDING'">
                                {{$t('3409')}}
                            </span>
                            <span class="l-spacing39 t-color-headlineBlack font-r t-body3" v-else-if="order.status && order.status.value==='REJECT_REFUND' || order.status.value==='REJECT'">
                                {{$t('3410')}}
                            </span>
                            <span class="l-spacing39 t-color-headlineBlack font-r t-body3" v-else-if="order.status && order.status.value==='REFUNDED' || order.status.value==='APPROVAL'">
                                {{$t('3411')}}
                            </span>
                            <span class="l-spacing39 t-color-headlineBlack font-r t-body3" v-else-if="order.status && order.status.value==='FAIL_REFUND'">
                                {{$t('3412')}}
                            </span>
                            <span class="l-spacing39 t-color-headlineBlack font-r t-body3" v-else>
                                {{order.status.value}}
                            </span>
                            <span class="l-spacing39 t-color-bodyGrayA pdl-8 pdr-16 t-body3 font-r">
                                {{order.orderDate ? $moment(order.orderDate).format('L') : ''}}
                            </span>
                        </div>
                        <div>
                            {{order.code}}
                        </div>
                        
                    </div>

                </div>
                <div class="divider" v-if="index != listData.length - 1"></div>
                <!-- <hr class="divider"> -->
            </div>
        </div>
            </div>
        </main>
        <infinite-loading @infinite="fetchData" spinner="spiral" class="container--narrow">
            <div slot="no-more" class="pdt-16 pdb-16"></div>
            <div slot="no-results" class="pdt-16 pdb-16"></div>
        </infinite-loading>
    </div>
</template>

<script>
/**
 * 멤버십 - 구매 목록 컴포넌트(membership - purchase list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import {topAppBarMixin} from '../../mixins/topAppBar.js'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
//import TopAppBar from '@/components/TopAppBar.vue'
import salesApi from '@/api/salesApi.js'
import NoData from '../common/NoData.vue'
import InfiniteLoading from 'vue-infinite-loading'

export default {
    components: {
        NoData, InfiniteLoading,TopAppBarDrawer
    },

    mixins: [topAppBarMixin],

    data() {
        return {
            status: '',
            isNoData: false,
            listData: [],
            currentPage: 1,
            totalPages: 1,
            infiniteId: +new Date(),
        }
    },
    
    updated() {
        // this.$parent.setTopAppBarCustom({
        //     leftBtnMode: 'menu',
        //     rightBtnMode: '',
        //     title: this.$t('1020'), //'나의 구매 내역',
        //     leftBtnMethod: () => {
        //     },
        //     rightBtnMethod: '',
        // })
        
        const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
            let ripple = new MDCRipple.attachTo(el)
            return ripple
        })
    },

    methods: {

        // 목록 데이터 로딩(get list data)
        fetchData($state) {
            let responseData = null
            let params = this.setParams()

            if (this.totalPages >= this.currentPage) {
                salesApi.refundOrderList(params).then((response) => {
                    responseData = response.data.data
                    
                    if(responseData.length > 0){
                        this.listData = this.listData.concat(responseData)
                        this.currentPage++
                        //this.totalPages = responseData.totalPages
                        //this.totalPages = responseData.length
                        
                        if (responseData.length) {
                            $state.loaded()
                        }else {
                            $state.complete()
                        }
                        if (!this.listData.length) {
                            this.isNoData = true
                        } else if(responseData.length<1) {
                            this.isNoData = true
                        }

                        this.infiniteId += 1

                        this.$parent.setTopAppBarCustom({
                            leftBtnMode: 'menu',
                            rightBtnMode: '',
                            title: localStorage.getItem('brandName'), //'나의 구매 내역',
                            leftBtnMethod: () => {
                                //this.$parent.moveParentRouter()
                            },
                            rightBtnMethod: '',
                        })
                    } else {
                        $state.complete()
                        this.isNoData = true
                    }
                })
            }else {
                $state.complete()
            }
        },

        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                page: this.currentPage,
                size: 10,
                //sort: 'id,desc'

            }
            return params
        },

        // move view
        movePurchaseRefundView(id) {
            this.$router.push({
                name: 'MemberPurchaseRefundView',
                params: {orderId: id}                
            })
        }
    }
}
</script>